import React from "react"

import asoleacion from "./../../../UI/general/asoleacion.svg"

interface Props{
    colorsData: any,
    handleOpenAsoleacionModal: any
}

interface State{
    isHovered: boolean
}

class AsoleacionBtn extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            isHovered: false
        }
    }

    render(): React.ReactNode {
        return(
            <div 
                className="asoleacion-btn"
                style={{
                    backgroundColor: this.state.isHovered ? this.props.colorsData.secondary_buttons : "#FAFAFA",
                    transition: "all 0.3s ease-in-out"
                }}
                onMouseEnter = {() => {this.setState({isHovered: true})}}
                onMouseLeave = {() => {this.setState({isHovered: false})}}
                onClick = {() => {this.props.handleOpenAsoleacionModal()}}
            >
                <img src={asoleacion} alt="" className="asolacion-btn-image"/>
                <div className="asoleacion-btn-title">Asoleación</div>
            </div>
        )
    }
}

export default AsoleacionBtn